<template>
  <div class="d-flex align-center" @click="$emit('click')" style="cursor: pointer">
    <img height="36" src="@/assets/logo-icon.svg" />
   <!--  <img height="24" class="ml-2 mt-1" src="@/assets/m/logo-label.svg" /> -->
    <div v-if="hideTitle !== true" class="sg-logo pl-2">{{visibleTitle}}</div>
  </div>
</template>

<script>
export default {
    props: {
        hideTitle: Boolean,
        title: String
    },
    computed: {
        visibleTitle() {
            return this.title || "Система \"Город\""
        }
    }
}
</script>


<style>
/*   @font-face {
    font-family: 'MagistralC';
    font-style: normal;
    font-weight: 300;
    src: url("../assets/fonts/MagistralC.otf") format("opentype");
  } */

   .sg-logo {
/*     font-family: 'MagistralC', sans-serif; */
    font-size: 24px;

  }
</style>